import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Composant pour protéger les routes d'administration
 * Redirige vers la page de login si l'utilisateur n'est pas connecté
 */
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  
  // Vérifier si le token est présent dans le localStorage
  const token = localStorage.getItem('token');
  
  useEffect(() => {
    // Vérification supplémentaire du token
    if (!token && !loading) {
      console.log('Token non trouvé, redirection vers la page de login');
      navigate('admin/login');
    }
  }, [token, loading, navigate]);
  
  // Pendant le chargement, afficher un indicateur de chargement
  if (loading) {
    return <div>Chargement...</div>;
  }
  
  // Si l'utilisateur n'est pas connecté, rediriger vers la page de login
  if (!user && !token) {
    console.log('Utilisateur non connecté, redirection vers la page de login');
    return <Navigate to="/login" replace />;
  }
  
  // Si l'utilisateur est connecté, afficher le contenu protégé
  return children;
};

export default ProtectedRoute;
